import { ScoreType } from '../eventFormats/store';

export type TIFormatPrefix =
  | 'stroke'
  | 'horse'
  | 'skins'
  | 'teamstroke'
  | 'ctp'
  | 'gbn'
  | 'moneyball'
  | 'moneyBall'
  | 'scramble';

export interface IFormat {
  adjustedHandicap: boolean;
  eventLeaderboard: boolean;
  holeLeaderboard: boolean;
  id: number;
  isContest: boolean;
  match: boolean;
  name: string;
  optionalFlight: boolean;
  optionalRound: boolean;
  optionalScores: boolean;
  optionalStrikes: boolean;
  optionalStableford: boolean;
  prefix: TIFormatPrefix;
  scoreAggregation: boolean;
  teams: boolean;
  useAuxScore: boolean;
}

export interface IHolesPerRound {
  [roundId: number]: number[];
}

export type TParScoreType = -3 | -2 | -1 | 0 | 1 | 2 | 3;

interface IMetadata extends IHolesPerRound {
  stableford?: Record<TParScoreType, number>;
}

export interface IMetaFormat {
  adjustedHandicap: boolean;
  aggregations: number[];
  considerFlights: boolean;
  event: number;
  format: IFormat;
  id: number;
  relevantScores: number;
  rounds: number[];
  scoreTypes: ScoreType[];
  strikes: number;

  scoreAggregation: number;
  betterBallScores: number;

  scoreType: number;
  scoringFormat: number;

  metadata: IMetadata | null;
}

export interface IMetaFormatBluePrint {
  adjustedHandicap: boolean;
  aggregations: number[];
  format: number;
  id: number;
  metadata: IMetadata | null;
  relevantScores: number;
  rounds: number[];
  scoreTypes: number[];
  strikes: number;
}

export interface IAdminRoundFormatsStore {
  masterFormats: IFormat[];
  [roundId: number]: IMetaFormat[];
  roundFormats: { [roundId: number]: IMetaFormat[] };
}

export const adminRoundFormatsStore: IAdminRoundFormatsStore = {
  masterFormats: [],
  roundFormats: {}
};
